import { es } from './es';
import { esCr } from './esCr';
import { pt } from './pt';

const locale = {
  pt,
  es,
  'es-CR': esCr as typeof es,
  'es-UY': {} as typeof es,
};

export default locale;
